import { render } from "./TableHeader.vue?vue&type=template&id=10b37da0"
import script from "./TableHeader.vue?vue&type=script&lang=js"
export * from "./TableHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/lucas/projects/distrisuper/pc-21/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__